const ValidationError = require('./errors/ValidationError');
const { banks, errors } = require('@transfeeradev/api-enums');
const Default = require('./Default');
const ItauService = require('./services/ItauService');

module.exports = class Itau extends Default {
  constructor(data) {
    super('Itau', data, banks.ITAU.code);
    this._data.agency = this._removeUnnecessaryLeadingZeros(this._data.agency, this._agencySchemaLength);
    this._data.account = this._removeUnnecessaryLeadingZeros(this._data.account, this._accountSchemaLength);
  }

  _validateAgency() {
    super._validateAgency();
    this._data.agency = this._fillZero(this._data.agency, this._agencySchemaLength);
  }

  _validateAccount() {
    super._validateAccount();

    if (ItauService.isItiAccount(this._data.agency)) {
      return;
    }

    const accDigit = this.getAccountDigit().toString();
    if (accDigit !== this._data.account_digit) {
      const error = errors.ptBr.dba.AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID_2;
      throw new ValidationError(
        error.message,
        error.field,
        {
          account_digit: accDigit
        },
        error.code
      );
    }
  }

  getAccountDigit() {
    const bankNumber =
      this._fillZero(this._data.agency, this._agencySchemaLength) +
      this._fillZero(this._data.account, this._accountSchemaLength);
    let result = 0;

    for (let i = 0; i < bankNumber.length; i++) {
      const multiplier = i % 2 === 0 ? 2 : 1;
      let calc = Number(bankNumber[i]) * multiplier;
      if (calc > 9) {
        calc = String(calc)
          .split('')
          .reduce((a, b) => Number(a) + Number(b), 0);
      }

      result += calc;
    }

    result = result % 10;
    if (result === 0) {
      return result;
    }

    return 10 - result;
  }
};
